<div class="dining-bg">
</div>
<div id="outer_container">
    <div class="container-fluid noPadding">
    <!-- uiView: content -->
        <div
            id="content"
            ui-view="content"
            class="angular-animate ng-scope"
            autoscroll="true"
            mtc-scroll-to-invalid=""
        >
            <!-- video controls -->
            <!-- <div class="video-control">
                <button id="myBtn" class="btn2 btn2-light" onclick="myFunction()"></button>
            </div> -->
            <!-- video controls -->
            <div class="ng-scope">
            <div class="container">
                <div class="home">
                    <div class="type-container ng-scope">
                        <div class="type-headline">
                            <h1>Dining</h1>
                        </div>
                        <div class="type-copy">
                            <div class="accordion mb-3" id="diningAccordion">
                                <div class="accordion-item">
                                    <h2 class="accordion-header">
                                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
                                    At Leisure Dining
                                    </button>
                                    </h2>
                                    <div id="collapseOne" class="accordion-collapse collapse" data-bs-parent="#faqAccordion">
                                        <div class="accordion-body">
                                            <p>To assist with dining information for your meals at leisure, explore <a href="https://www.visitmonaco.com/en/enjoy/restaurants" target="_blank">Where to Eat in the Principality</a>. The restaurants at the Fairmont Monte Carlo are listed below. For additional details and menus for lunch options at the hotel, please visit the Fairmont Monte Carlo&rsquo;s <a href="https://www.fairmont.com/en/hotels/monte-carlo/fairmont-monte-carlo/dining.html" target="_blank">dining page</a>.</p>
                            
                                            <p><strong>Lobby Lounge Restaurant and Bar:</strong> This chic, sophisticated lounge beckons you to luxuriate over an artisanal cocktail with gourmet hors d&rsquo;oeuvres, elevated comfort food or seafood and meat dishes infused with Mediterranean flavors. Panoramic views of the sea evoke the feeling of sailing away on the sapphire waters as you savor your delightful dishes.</p>
                                            
                                            <p><strong>Nobu:</strong> Globally renowned Chef Nobu Matsuhisa brings his signature culinary style to Monte Carlo. An artistic blend of Japanese cuisine and Peruvian inspiration is elevated to new heights with the stunning Mediterranean views beyond the wall of windows. Terrace seating is available for alfresco dining, and the sophisticated bar is the perfect spot for enjoying pre- or post-dinner cocktails to enhance your dining experience.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>                            
                        
                            <h2>Dine Your Way</h2>
                            <p>For your &ldquo;Dine Your Way&rdquo; dinner, you&rsquo;ll find Michelin-starred restaurants, celebrity chef restaurants, signature restaurants and casual cafes in Monte Carlo. All restaurants will have one seating time, combined table seating with your fellow winners and a pre-determined group menu. The list of restaurants below includes descriptions to allow you to make your selection.</p>
                            
                            <p>Please note that on-site changes are limited and based on availability.</p>

                            @if (version() !== 'GSCS') {
                                <p class="diner-h"><strong>Offered: </strong>Tuesday, March 16</p>
                                <div class="card-deck justify-content-center mx-4 mt-4">
                                    <div class="card mb-4 mb-lg-0 mx-auto mx-lg-0 me-lg-4">
                                        <img class="card-img-top" src="assets/images/restaurants/avenue31.jpg" alt="Card image cap">
                                        <div class="card-body">
                                            <h5 class="card-title greycliff-cf-bold">Avenue 31</h5>
                                        </div>
                                        <div class="card-footer">
                                            <a data-bs-toggle="modal" data-bs-target="#avenue31Modal" class="card-btn stretched-link">Learn more<img class="chevron" src="assets/icons/chevron_right.svg"></a>
                                        </div>
                                    </div>
                                    <div class="card mb-4 mb-lg-0 mx-auto mx-lg-0 me-lg-4">
                                        <img class="card-img-top" src="assets/images/restaurants/crazyPizza.png" alt="Card image cap">
                                        <div class="card-body">
                                            <h5 class="card-title greycliff-cf-bold">Crazy Pizza</h5>
                                            
                                        </div>
                                        <div class="card-footer">
                                            <a data-bs-toggle="modal" data-bs-target="#crazyPizzaModal" class="card-btn stretched-link">Learn more<img class="chevron" src="assets/icons/chevron_right.svg"></a>
                                        </div>
                                    </div>
                                    <div class="card mb-4 mb-lg-0 mx-auto mx-lg-0 me-lg-4">
                                        <img class="card-img-top" src="assets/images/restaurants/noteBleue.jpg" alt="Card image cap">
                                        <div class="card-body">
                                            <h5 class="card-title greycliff-cf-bold">La Note Bleue</h5>
                                            
                                        </div>
                                        <div class="card-footer">
                                            <a data-bs-toggle="modal" data-bs-target="#laNoteBleueModal" class="card-btn stretched-link">Learn more<img class="chevron" src="assets/icons/chevron_right.svg"></a>
                                        </div>
                                    </div>
                                </div>

                                <div class="card-deck justify-content-center mx-4 mt-4">
                                    <div class="card mb-4 mb-lg-0 mx-auto mx-lg-0 me-lg-4">
                                        <img class="card-img-top" src="assets/images/restaurants/zeffirino.jpg" alt="Card image cap">
                                        <div class="card-body">
                                            <h5 class="card-title greycliff-cf-bold">Zeffirino</h5>
                                            
                                        </div>
                                        <div class="card-footer">
                                            <a data-bs-toggle="modal" data-bs-target="#zeffirinoModal" class="card-btn stretched-link">Learn more<img class="chevron" src="assets/icons/chevron_right.svg"></a>
                                        </div>
                                    </div>
                                </div>
                            }

                            @if (version() !== 'EDA') {
                                <p class="diner-h"><strong>Offered: </strong>Wednesday, March 17</p>
                                
                                <div class="card-deck justify-content-center mx-4 mt-4">
                                    <div class="card mb-4 mb-lg-0 mx-auto mx-lg-0 me-lg-4">
                                        <img class="card-img-top" src="assets/images/restaurants/avenue31.jpg" alt="Card image cap">
                                        <div class="card-body">
                                            <h5 class="card-title greycliff-cf-bold">Avenue 31</h5>
                                        </div>
                                        <div class="card-footer">
                                            <a data-bs-toggle="modal" data-bs-target="#avenue31Modal" class="card-btn stretched-link">Learn more<img class="chevron" src="assets/icons/chevron_right.svg"></a>
                                        </div>
                                    </div>
                                    <div class="card mb-4 mb-lg-0 mx-auto mx-lg-0 me-lg-4">
                                        <img class="card-img-top" src="assets/images/restaurants/beefbar.png" alt="Card image cap">
                                        <div class="card-body">
                                            <h5 class="card-title greycliff-cf-bold">Beef Bar</h5>
                                            
                                        </div>
                                        <div class="card-footer">
                                            <a data-bs-toggle="modal" data-bs-target="#beefbarModal" class="card-btn stretched-link">Learn more<img class="chevron" src="assets/icons/chevron_right.svg"></a>
                                        </div>
                                    </div>
                                    <div class="card mb-4 mb-lg-0 mx-auto mx-lg-0 me-lg-4">
                                        <img class="card-img-top" src="assets/images/restaurants/castleRoc.jpg" alt="Card image cap">
                                        <div class="card-body">
                                            <h5 class="card-title greycliff-cf-bold">Castle Roc</h5>
                                            
                                        </div>
                                        <div class="card-footer">
                                            <a data-bs-toggle="modal" data-bs-target="#castleRocModal" class="card-btn stretched-link">Learn more<img class="chevron" src="assets/icons/chevron_right.svg"></a>
                                        </div>
                                    </div>
                                </div>

                                <div class="card-deck justify-content-center mx-4 mt-4">
                                    <div class="card mb-4 mb-lg-0 mx-auto mx-lg-0 me-lg-4">
                                        <img class="card-img-top" src="assets/images/restaurants/crazyPizza.png" alt="Card image cap">
                                        <div class="card-body">
                                            <h5 class="card-title greycliff-cf-bold">Crazy Pizza</h5>
                                            
                                        </div>
                                        <div class="card-footer">
                                            <a data-bs-toggle="modal" data-bs-target="#crazyPizzaModal" class="card-btn stretched-link">Learn more<img class="chevron" src="assets/icons/chevron_right.svg"></a>
                                        </div>
                                    </div>
                                    <div class="card mb-4 mb-lg-0 mx-auto mx-lg-0 me-lg-4">
                                        <img class="card-img-top" src="assets/images/restaurants/giacomo.jpg" alt="Card image cap">
                                        <div class="card-body">
                                            <h5 class="card-title greycliff-cf-bold">Giacomo</h5>
                                            
                                        </div>
                                        <div class="card-footer">
                                            <a data-bs-toggle="modal" data-bs-target="#giacomoModal" class="card-btn stretched-link">Learn more<img class="chevron" src="assets/icons/chevron_right.svg"></a>
                                        </div>
                                    </div>
                                    <div class="card mb-4 mb-lg-0 mx-auto mx-lg-0 me-lg-4">
                                        <img class="card-img-top" src="assets/images/restaurants/laMome.jpeg" alt="Card image cap">
                                        <div class="card-body">
                                            <h5 class="card-title greycliff-cf-bold">La M&ocirc;me</h5>
                                            
                                        </div>
                                        <div class="card-footer">
                                            <a data-bs-toggle="modal" data-bs-target="#laMomeModal" class="card-btn stretched-link">Learn more<img class="chevron" src="assets/icons/chevron_right.svg"></a>
                                        </div>
                                    </div>
                                </div>

                                <div class="card-deck justify-content-center mx-4 mt-4">
                                    <div class="card mb-4 mb-lg-0 mx-auto mx-lg-0 me-lg-4">
                                        <img class="card-img-top" src="assets/images/restaurants/noteBleue.jpg" alt="Card image cap">
                                        <div class="card-body">
                                            <h5 class="card-title greycliff-cf-bold">La Note Bleue</h5>
                                            
                                        </div>
                                        <div class="card-footer">
                                            <a data-bs-toggle="modal" data-bs-target="#noteBleueModal" class="card-btn stretched-link">Learn more<img class="chevron" src="assets/icons/chevron_right.svg"></a>
                                        </div>
                                    </div>
                                    <div class="card mb-4 mb-lg-0 mx-auto mx-lg-0 me-lg-4">
                                        <img class="card-img-top" src="assets/images/restaurants/songQi.png" alt="Card image cap">
                                        <div class="card-body">
                                            <h5 class="card-title greycliff-cf-bold">Song Qi</h5>
                                            
                                        </div>
                                        <div class="card-footer">
                                            <a data-bs-toggle="modal" data-bs-target="#songQiModal" class="card-btn stretched-link">Learn more<img class="chevron" src="assets/icons/chevron_right.svg"></a>
                                        </div>
                                    </div>
                                    <div class="card mb-4 mb-lg-0 mx-auto mx-lg-0 me-lg-4">
                                        <img class="card-img-top" src="assets/images/restaurants/zeffirino.jpg" alt="Card image cap">
                                        <div class="card-body">
                                            <h5 class="card-title greycliff-cf-bold">Zeffirino</h5>
                                            
                                        </div>
                                        <div class="card-footer">
                                            <a data-bs-toggle="modal" data-bs-target="#zeffirinoModal" class="card-btn stretched-link">Learn more<img class="chevron" src="assets/icons/chevron_right.svg"></a>
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
            </div>
        </div>
    </div>
</div>


<div class="modal fade" id="avenue31Modal" tabindex="-1" aria-labelledby="avenue31Label" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header row g-0 row g-0">
        <img class="activity-img" src="assets/images/restaurants/avenue31.jpg">
        <h5 class="modal-title col-11 col-11" id="flowerMakingLabel">Avenue 31</h5>
        <button type="button" class="btn-close col-1" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
            <p>Located on the prestigious Avenue Princesse Grace with views of Larvotto Beach, Avenue 31 offers sophisticated Italian and Mediterranean dishes crafted with fresh, seasonal flavors.</p>

      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary btn-activities" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="crazyPizzaModal" tabindex="-1" aria-labelledby="crazyPizzaLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header row g-0">
        <img class="activity-img" src="assets/images/restaurants/crazyPizza.png">
        <h5 class="modal-title col-11" id="crazyPizzaLabel">Crazy Pizza</h5>
        <button type="button" class="btn-close col-1" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <p>This lively waterfront restaurant overlooks Port Hercule and the Monaco Grand Prix circuit. Known for its thin-crust Italian pizzas, vibrant atmosphere and live entertainment, it features a fun and distinctly glamorous Riviera dining experience.</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary btn-activities" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="laNoteBleueModal" tabindex="-1" aria-labelledby="wineTastingLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header row g-0">
        <img class="activity-img" src="assets/images/restaurants/noteBleue.jpg">
        <h5 class="modal-title col-11" id="wineTastingLabel">La Note Bleue</h5>
        <button type="button" class="btn-close col-1" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <p>La Note Bleue pairs creative Mediterranean flavors with a laid-back beach club vibe on Larvotto Beach, where fresh seasonal dishes are served alongside panoramic views and live music.</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary btn-activities" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="zeffirinoModal" tabindex="-1" aria-labelledby="zeffirinoLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header row g-0">
        <img class="activity-img" src="assets/images/restaurants/zeffirino.jpg">
        <h5 class="modal-title col-11" id="zeffirinoLabel">Zeffirino</h5>
        <button type="button" class="btn-close col-1" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <p>Discover Ligurian cuisine at Zeffirino, the celebrated Italian restaurant renowned for its traditional Genoese pesto and handmade pastas. Just steps from Monaco's Carr&eacute; d'Or, it offers a refined yet welcoming atmosphere rooted in Italian culinary heritage.</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary btn-activities" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="beefbarModal" tabindex="-1" aria-labelledby="beefbarLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header row g-0">
        <img class="activity-img" src="assets/images/restaurants/beefbar.png">
        <h5 class="modal-title col-11" id="beefbarLabel">Beef Bar</h5>
        <button type="button" class="btn-close col-1" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <p>Blending world-class beef with a modern, cosmopolitan approach, Beef Bar has earned an international reputation for quality and innovation. Its carefully curated menu showcases premium cuts sourced from leading producers around the world.</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary btn-activities" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="castleRocModal" tabindex="-1" aria-labelledby="castleRocLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header row g-0">
        <img class="activity-img" src="assets/images/restaurants/castleRoc.jpg">
        <h5 class="modal-title col-11" id="castleRocLabel">Castle Roc</h5>
        <button type="button" class="btn-close col-1" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <p>Rooted in four generations of family tradition, Castle Roc celebrates the flavors of the Riviera through classic Monegasque recipes and locally sourced ingredients. The restaurant offers an authentic connection to Monte Carlo's rich culinary past.</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary btn-activities" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="giacomoModal" tabindex="-1" aria-labelledby="giacomoLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header row g-0">
        <img class="activity-img" src="assets/images/restaurants/giacomo.jpg">
        <h5 class="modal-title col-11" id="giacomoLabel">Giacomo</h5>
        <button type="button" class="btn-close col-1" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <p>Bringing the charm of a vintage Italian trattoria to Monte Carlo, Giacomo pairs generous Italian cooking with a relaxed coastal spirit. Traditional recipes and vibrant Mediterranean flavors define its welcoming menu.</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary btn-activities" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="laMomeModal" tabindex="-1" aria-labelledby="laMomeLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header row g-0">
        <img class="activity-img" src="assets/images/restaurants/laMome.jpeg">
        <h5 class="modal-title col-11" id="laMomeLabel">La M&ocirc;me</h5>
        <button type="button" class="btn-close col-1" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <p>Inspired by the glamour of the French Riviera in the 1920s, La M&ocirc;me serves refined Mediterranean cuisine in a chic rooftop setting above Port Hercule. Seasonal ingredients, elegant presentation and a lively social atmosphere define the experience.</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary btn-activities" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="noteBleueModal" tabindex="-1" aria-labelledby="noteBleueLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header row g-0">
        <img class="activity-img" src="assets/images/restaurants/noteBleue.jpg">
        <h5 class="modal-title col-11" id="noteBleueLabel">La Note Bleue</h5>
        <button type="button" class="btn-close col-1" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <p>La Note Bleue pairs creative Mediterranean flavors with a laid-back beach club vibe on Larvotto Beach, where fresh seasonal dishes are served alongside panoramic views and live music.</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary btn-activities" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="songQiModal" tabindex="-1" aria-labelledby="songQiLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header row g-0">
        <img class="activity-img" src="assets/images/restaurants/songQi.png">
        <h5 class="modal-title col-11" id="songQiLabel">Song Qi</h5>
        <button type="button" class="btn-close col-1" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <p>Renowned for its refined Chinese cuisine, Song Qi offers a sophisticated blend of tradition and innovation. From delicate dim sum to its celebrated Peking duck, each dish reflects exceptional craftsmanship.</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary btn-activities" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>